import React, {useCallback, useEffect, useRef, useState} from "react";
import styled from "styled-components";

const SNPNotification = styled.div`
    position: absolute;
    width: 100%;
    height: 100%;
    display: ${props => props.show ? "flex" : "none"};
    opacity: 0;
    transition: 0.75s opacity;
    z-index: 200;
    background: #000000f0;
    align-content: stretch;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    flex-wrap: nowrap;
    
    > .first {
        transition: 1s opacity;
        opacity: 0;
        font-size: 44px;
        font-weight: 200;
        flex-grow: 1;
        display: flex;
        align-items: center;
    }
    
    > .second {
        transition: 1.5s opacity;
        opacity: 0;
        font-size: 144px;
        font-weight: 600;
        flex-grow: 2;
        text-align: center;
    }
    
`;

export function NextPlaylistNotification({lastNotification}) {
    const [show, setShow] = useState(false);
    const [playlistName, setPlaylistName] = useState(null);

    useEffect(() => {
        if (show) {
            setTimeout(() => {
                document.getElementById("npnotification-container").style.opacity = 1;
                setTimeout(() => {
                    document.getElementById("npn-first").style.opacity = 1;
                }, 1000);
                setTimeout(() => {
                    document.getElementById("npn-second").style.opacity = 1;
                }, 2000);
                setTimeout(() => {
                    document.getElementById("npnotification-container").style.opacity = 0;
                    setTimeout(() => {
                        setShow(false);
                        document.getElementById("npn-second").style.opacity = 0;
                        document.getElementById("npn-first").style.opacity = 0;
                    }, 750);
                }, 5000)
            }, 100);

        }
    }, [show]);

    useEffect(() => {
        if (lastNotification?.event_type === "new_playlist") {
            setShow(true);
            setPlaylistName(lastNotification?.event_data?.playlist_name);
        }
    }, [lastNotification]);

    return <SNPNotification show={show} id="npnotification-container">
        <div className="first" id="npn-first">
            Сейчас играет плейлист
        </div>
        <div className="second" id="npn-second">
            {playlistName}
        </div>
    </SNPNotification>;
}
